    function msClarity() {
          let userCanBeTracked = window.Shopify.customerPrivacy.analyticsProcessingAllowed();
          if(userCanBeTracked) {
            (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "nffelpqhzo");
          }
    }

    window.Shopify.loadFeatures([
          {
            name: 'consent-tracking-api',
            version: '0.1',
          }
          ],
          function(error) {
            if (error) {
              throw error;
            }
            msClarity();
            document.addEventListener('visitorConsentCollected', () => {
              msClarity();
            });
    });
